export default "/images/da21eda7ee2e1ef8b77b28cab2845b21.avif";